import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

const Services = () => {
  const { t } = useTranslation();
  const services = t('services.list', { returnObjects: true });
  
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-burgundy via-burgundy-dark to-burgundy text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-cream-gold rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-cream-gold rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold leading-tight text-white">
            {t('services.title')}
          </h2>
          <p className="text-xl text-cream-gold-light max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {services.map((service, index) => (
            <div 
              key={index}
              className="flex items-center gap-4 p-6 bg-white/10 backdrop-blur-md rounded-2xl border-2 border-white/20 hover:border-cream-gold hover:bg-white/20 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-cream-gold/30"
            >
              <div className="flex-shrink-0 w-10 h-10 bg-cream-gold rounded-full flex items-center justify-center shadow-lg">
                <Check className="w-5 h-5 text-burgundy-darkest" strokeWidth={3} />
              </div>
              <span className="text-lg font-semibold text-white">{service}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
